import { createRouter, createWebHistory } from 'vue-router';

import LoginPage from './modules/auth/LoginPage.vue';
import ProductListPage from './modules/products/product-list/ProductListPage.vue';
import { useAuth } from './modules/auth/auth';
import ProductDetailPage from './modules/products/product-detail/ProductDetailPage.vue';
import AdminUserListPage from '@/modules/admin/users/user-list/AdminUserListPage.vue';
import AdminTransactionsPage from '@/modules/admin/transactions/AdminTransactionsPage.vue';
import AdminDeviceSessionsPage from '@/modules/admin/device-sessions/AdminDeviceSessionsPage.vue';
import AdminNewUsersPage from '@/modules/admin/users/new/AdminNewUsersPage.vue';
import UnclaimedStripePaymentsPage from '@/modules/admin/unclaimed-stripe-payments/UnclaimedStripePaymentsPage.vue';
import WebarealLogin from './modules/integrations/webareal/WebarealLogin.vue';
import WebarealCallback from './modules/integrations/webareal/WebarealCallback.vue';
import ShoptetPluginSettingsPage from './modules/integrations/shoptet/ShoptetPluginSettingsPage.vue';
import UsagePage from './modules/usage/UsagePage.vue';
import UsersPage from './modules/users/UsersPage.vue';
import ApiPage from './modules/api/ApiPage.vue';
import ExternalProductsPage from './modules/external-products/ExternalProductsPage.vue';
import ExternalProductImagesPage from './modules/external-products/ExternalProductImagesPage.vue';

const routes = [
  { path: '/login', component: LoginPage, meta: { title: 'Login' } },
  { path: '/', redirect: '/products' },
  {
    path: '/products',
    component: ProductListPage,
    meta: { requiresAuth: true, title: 'Products' },
  },
  {
    path: '/products/:id',
    component: ProductDetailPage,
    meta: { requiresAuth: true, title: 'Product' },
  },
  { path: '/usage', component: UsagePage, meta: { requiresAuth: true, title: 'Usage' } },
  { path: '/users', component: UsersPage, meta: { requiresAuth: true, title: 'Users' } },
  {
    path: '/api-settings',
    component: ApiPage,
    meta: { requiresAuth: true, title: 'Settings' },
  },
  {
    path: '/external-products',
    component: ExternalProductsPage,
    meta: { requiresAuth: true, title: 'External Products' },
  },
  {
    path: '/external-product-images',
    component: ExternalProductImagesPage,
    meta: { requiresAuth: true, title: 'External Images' },
  },
  {
    path: '/admin/users',
    component: AdminUserListPage,
    meta: { requiresAuth: true, title: 'Admin / All Users' },
  },
  {
    path: '/admin/users/new',
    component: AdminNewUsersPage,
    meta: { requiresAuth: true, title: 'Admin / New Users' },
  },
  {
    path: '/admin/transactions',
    component: AdminTransactionsPage,
    meta: { requiresAuth: true, title: 'Admin / Transactions' },
  },
  {
    path: '/admin/device-sessions',
    component: AdminDeviceSessionsPage,
    meta: { requiresAuth: true, title: 'Admin / Sessions' },
  },
  {
    path: '/admin/unclaimed-stripe-payments',
    component: UnclaimedStripePaymentsPage,
    meta: { requiresAuth: true, title: 'Admin / Unclaimed Payments' },
  },
  {
    path: '/integrations/webareal/login',
    component: WebarealLogin,
    meta: { requiresAuth: true, title: 'Webareal' },
  },
  {
    path: '/integrations/webareal/callback',
    component: WebarealCallback,
    meta: { requiresAuth: true },
  },
  {
    path: '/integrations/shoptet/plugin-settings',
    component: ShoptetPluginSettingsPage,
    meta: { requiresAuth: false, title: 'Shoptet', lightTheme: true },
  },
  {
    path: '/integrations/shoptet/plugin-settings-dev',
    component: ShoptetPluginSettingsPage,
    meta: { requiresAuth: false, title: 'Shoptet', lightTheme: true },
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.lightTheme) {
    document.documentElement.classList.remove('p-dark');
  } else {
    document.documentElement.classList.add('p-dark');
  }

  const { waitForReady, isAuthenticated } = useAuth();

  await waitForReady();

  if (to.meta.requiresAuth) {
    if (isAuthenticated.value) {
      next();
    } else {
      next('/login');
    }
  } else {
    // Non-protected route, allow access
    next();
  }
});
